import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';

const POSTER_ROWS = [
  ['/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg'],
  ['/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg'],
  ['/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg','/posters/Dolls_of_VooDoo.jpg','/posters/Dark_Knight_Poster.jpg','/posters/Mission_Impossible_poster.jpeg'],
];

export default function Home() {
  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.gallery} aria-hidden="true">
          {POSTER_ROWS.map((row, ri) => (
            <div key={ri} className={`${styles.marqueeTrack} ${ri % 2 === 1 ? styles.reverse : ''}`}>
              {[...row, ...row].map((src, i) => (
                <div key={i} className={styles.marqueeImg}>
                  <img src={src} alt="" loading="lazy" />
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className={styles.heroOverlay} />

        <div className={styles.heroContent}>
          <span className={styles.voteTo}>
            vote to
            <svg className={styles.voteArrow} viewBox="0 0 60 50" fill="none" aria-hidden="true">
              {/* Curved path from upper-left, arcing down-right */}
              <path d="M8 6 C 18 10, 28 20, 38 40" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" fill="none" />
              {/* Arrowhead at (38,40) pointing DOWN-right */}
              <path d="M30 34 L 38 40 L 34 32" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </span>

          <h1 className={styles.heroTitle}>
            <span className={styles.heroLine1}>Make Movies Happen</span>
            <span className={styles.heroLine2}>
              <span className={styles.heroAccent}>(Because Hollywood Won't)</span>
            </span>
          </h1>

          {/* H16: WhatBox moved into hero — gives users immediate context before the audience choice. */}
          <div className={styles.whatBox}>
            <div className={styles.whatTitle}>What is <span>VoxPop</span>?</div>
            <p className={styles.whatPara}>
              Crowdfunding platform + streaming service + disregard for "the rules" = VoxPop,
              the only streaming platform that puts YOU in charge.
            </p>
            <p className={styles.whatPara}>
              Filmmakers post trailers. You vote with <strong>real dollars.</strong> The winning
              films get made. And just like that, you're making cinematic history.
            </p>
          </div>
        </div>
      </section>

      {/* H16: Audience cards lifted out of hero into their own dedicated section.
          Lets the choice breathe and reads as "here's what we are, now pick your path". */}
      <section className={styles.audienceSection}>
        <div className={styles.audienceGrid}>
          <Link to="/trailers" className={`${styles.audienceCard} ${styles.audienceCardPrimary}`}>
            <span className={styles.audienceEyebrow}>I'm a</span>
            <span className={styles.audienceTitle}>Movie Lover</span>
            <span className={styles.audienceDesc}>Vote with your wallet. Stream what you greenlight.</span>
            <span className={styles.audienceArrow} aria-hidden="true">Browse trailers →</span>
          </Link>
          <Link to="/how-it-works#filmmaker" className={`${styles.audienceCard} ${styles.audienceCardOutline}`}>
            <span className={styles.audienceEyebrow}>I'm a</span>
            <span className={styles.audienceTitle}>Filmmaker</span>
            <span className={styles.audienceDesc}>Bypass the gatekeepers. Get your film funded.</span>
            <span className={styles.audienceArrow} aria-hidden="true">See how it works →</span>
          </Link>
        </div>
      </section>

      <section className={styles.howSection}>
        {/* Quote first — the setup/hook */}
        <blockquote className={styles.quote}>
          <p>"VoxPop makes me feel like a hotshot producer, without the cocaine habit and the soul-crushing moral compromises."</p>
          <cite>— A real human, probably</cite>
        </blockquote>

        {/* Label + heading sit directly above the bubble box */}
        <div className={styles.sectionLabel}>the uprising starts here</div>
        <h2 className={styles.sectionTitle}><span>How</span> Does It Work?</h2>

        {/* Bullets wrapped in magenta-bordered bubble box, matching WhatBox treatment */}
        <div className={styles.greenlightBox}>
          <ul className={styles.bullets}>
            <li className={styles.bulletPrimary}>
              <span className={styles.bulletDot} />
              <span><strong>Greenlight your next favorite film.</strong> Future You's favorite movie is stuck in development hell. Fall in love with a trailer, then vote with your wallet to rescue it from oblivion.</span>
            </li>
            <li className={styles.bullet}><span className={styles.bulletDot} /><span>Vote for what <em>you</em> want to watch</span></li>
            <li className={styles.bullet}><span className={styles.bulletDot} /><span>Early access, director Q&amp;As, and exclusive drops</span></li>
            <li className={styles.bullet}><span className={styles.bulletDot} /><span>Eternal bragging rights when your film hits Sundance</span></li>
          </ul>
        </div>

        {/* Bottom button — filled magenta pill, visually distinct from Hell Yeah */}
        <Link to="/how-it-works" className={styles.howBtnBottom}>Learn More Here!</Link>
      </section>

      <div className={styles.ctaBar}>
        <div className={styles.ctaBarInner}>
          <div>
            <div className={styles.ctaBarText}>The credits are rolling. Are you in them?</div>
            <div className={styles.ctaBarSub}>Be the reason a great story gets told. Sign up to watch trailers, vote, and join the indie film uprising.</div>
          </div>
          <Link to="/register" className="btn btn-dark btn-lg">Sign up</Link>
        </div>
      </div>
    </div>
  );
}
